import { render } from "./addBank.vue?vue&type=template&id=44efa998"
import script from "./addBank.vue?vue&type=script&lang=js"
export * from "./addBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__